import { prefixObjectValues } from '../utils';

const modal = {
  form: 'form',
  saveButton: '-save-button',
  submitButton: '-submit-button',
};

export default prefixObjectValues(modal, 'attestations-form');
